const data: string = "<md-dialog class=\"virtual-card-dialog\"><ng-include src=\"staticTemplate('components/virtual-cards-landing/templates/acp-virtual-cards-detail-content.ng.html')\"></ng-include></md-dialog>";
export default data